import { useContext } from 'react';
import { LoaderVisibilityContext } from './LoaderContext';

// Separate from useBlockingLoader() so that action-only consumers don't re-render on loader flips —
// subscribe here only when the component actually renders from visibility.
export default function useBlockingLoaderVisibility() {
  const isVisible = useContext(LoaderVisibilityContext);

  if (isVisible === null) {
    throw new Error(
      "useBlockingLoaderVisibility: no LoaderProvider mounted. Mount <LoaderProvider> (from 'shared') above anything that fetches.",
    );
  }

  return isVisible;
}
